import type { ReferentialSchedulingState } from "./referential-scheduling-states.type";
import type { UseReferentialOptions } from "@/entities/referential";

import { useReferential, REFERENTIAL_NAMES } from "@/entities/referential";

export const useReferentialSchedulingStates = (
  options?: UseReferentialOptions<ReferentialSchedulingState[]>
) => {
  const { data: schedulingStates = [], ...result } = useReferential<
    ReferentialSchedulingState[]
  >(REFERENTIAL_NAMES.SCHEDULING_STATES, options);

  return {
    ...result,
    schedulingStates,
  };
};
